import React from 'react';
import { FormattedMessage } from 'react-intl';
import TableRow from './TableRow';
import Loader from '../../Utils/Loader';
import Empty from './Empty';
import MobileCard from './MobileCard';
import classes from './styles.module.css';

function ProjectsList({ data = [], currentUuid, isLoading }) {
    if (isLoading) return <Loader />;
    if (!data.length) return <Empty />;

    return (
        <React.Fragment>
            <div className={classes.Scroll}>
                <table className={classes.Table}>
                    <thead>
                        <tr>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id="ProjectsList.table.createdAt" defaultMessage="Дата создания" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="ProjectsList.table.name" defaultMessage="Название" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="ProjectsList.table.website" defaultMessage="Сайт" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="ProjectsList.table.accounts" defaultMessage="Учетные записи" />
                            </th>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id="ProjectsList.table.status" defaultMessage="Статус" />
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((el) => (
                            <TableRow key={el && (el.uuid || el.id)} data={el} currentUuid={currentUuid} />
                        ))}
                    </tbody>
                </table>
            </div>
            {data.map((el) => (
                <MobileCard key={el && (el.uuid || el.id)} data={el} currentUuid={currentUuid} />
            ))}
        </React.Fragment>
    );
}

export default ProjectsList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectsList/index.js